
export type VerticalAlignment = 
  | 'top'
  | 'bottom'
  | 'center';